exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n@media(max-width: 769px){\n.form-div.select select[data-v-183bf5f5]{width:80%\n}\n}\n.formularios-busqueda[data-v-183bf5f5]{margin-top:1rem;margin-bottom:4.5rem\n}\n.formularios-busqueda select[data-v-183bf5f5]{border:1px solid #fff\n}\n.formularios-busqueda input[data-v-183bf5f5]{padding:.4rem\n}\n.form-blocks[data-v-183bf5f5]{margin:1rem 0\n}\n.form-blocks>div[data-v-183bf5f5]{width:33%\n}\n@media(max-width: 1024px){\n.formularios-busqueda[data-v-183bf5f5]{display:block;margin-top:0;margin-bottom:3rem\n}\n.form-blocks>div[data-v-183bf5f5]{width:100%\n}\n}\n.article h3.title-article[data-v-183bf5f5]{padding-bottom:1em\n}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-183bf5f5","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/dist/cjs.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/resources/ResourcesType.vue
// module id = ZTyI
// module chunks = 1